import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/data/site";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { applySessionUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    api.post("/auth/session", { session_id: sessionId })
      .then((res) => {
        window.history.replaceState(null, "", window.location.pathname);
        const u = res.data.user;
        applySessionUser(u, res.data.session_token);
        navigate(u.role === "admin" ? "/admin" : "/portal", { replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate, applySessionUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-light gap-6">
      <img src={LOGO_URL} alt="EXORA" className="h-14" />
      <div className="flex items-center gap-3 text-brand-green">
        <Loader2 className="h-6 w-6 animate-spin" />
        <span className="font-heading font-semibold">Signing you in…</span>
      </div>
    </div>
  );
}
